import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { ProjectsService } from "../services/projects.service";
import { AuthenticationService } from "../services/authentication.service";
import { UserService } from "../services/user.service";
import { PlansService } from "../services/plans.service";
import { IntellectualpropertyService } from "../services/intellectualproperty.service";
import { AngularFireStorage } from "@angular/fire/storage";
import { url } from "inspector";
import { forEach } from "@angular/router/src/utils/collection";

@Component({
  selector: "app-addproject",
  templateUrl: "./addproject.component.html",
  styleUrls: ["./addproject.component.css"],
})
export class AddprojectComponent implements OnInit {
  pageTitle = "Crear Producto";

  formRef: FormGroup;
  items: FormArray;

  imageChangedEvent: any = "";
  croppedImage: any = "";
  picture: any;
  myDate: Date;
  nameProject = "";
  descProject = "";
  planProject = "";
  urlProject = "";
  userProject = "";
  passProject = "";
  priceProject = "";
  propIntelectualProject = "";
  protocolProject = "";
  hostProject = "";
  portProject = "";
  pathProject = "";
  listInfoUrl: {} = {};
  plans: any[];
  properties: any[];
  planDuration = "";
  planType = "";
  expDateProject: Date;

  constructor(
    private projectService: ProjectsService,
    private authService: AuthenticationService,
    private userService: UserService,
    private fbStorage: AngularFireStorage,
    private planService: PlansService,
    private formBuilder: FormBuilder,
    private intellectualPropertyService: IntellectualpropertyService
  ) {}

  ngOnInit() {
    this.createForm();
    this.planService
      .getPlanForStatus("activo")
      .valueChanges()
      .subscribe(
        (data) => {
          this.plans = data;
        },
        (error) => {
          console.log(error);
        }
      );
    this.intellectualPropertyService
      .getPropertyForStatus("activo")
      .valueChanges()
      .subscribe(
        (property) => {
          this.properties = property;
        },
        (error) => {
          console.log(error);
        }
      );
  }
  createForm() {
    this.formRef = this.formBuilder.group({
      nameProject: ["", Validators.required],
      descProject: ["", Validators.required],
      planProject: ["", Validators.required],
      urlProject: ["", Validators.required],
      userProject: ["", Validators.required],
      passProject: ["", Validators.required],
      priceProject: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]+(.[0-9]{1,2})?"),
        ]),
      ],
      protocolProject: ["", Validators.required],
      hostProject: ["", Validators.required],
      portProject: ["", Validators.required],
      pathProject: ["", Validators.required],
      propIntelectualProject: ["", Validators.required],
      items: this.formBuilder.array([]),
    });
  }
  createItem(name, value): FormGroup {
    return this.formBuilder.group({
      name: name,
      value: value,
    });
  }

  breakeUrl() {
    this.items = this.formRef.get("items") as FormArray;
    while (this.items.length !== 0) {
      this.items.removeAt(0);
    }
    if (this.urlProject) {
      const urlNew = new URL(this.urlProject);
      this.protocolProject = urlNew.protocol;
      this.hostProject = urlNew.hostname;
      this.portProject = urlNew.port;
      this.pathProject = urlNew.pathname;
      this.listInfoUrl = {
        protocol: this.protocolProject,
        host: this.hostProject,
        port: this.portProject,
        path: this.pathProject,
      };
      const query = urlNew.search.substring(1);
      const vars = query.split("&");
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        this.items.push(this.createItem(pair[0], decodeURIComponent(pair[1])));
      }
    }
  }

  saveSettings() {
    const pid = Date.now();
    const currentUrl = btoa(window.location.host);
    this.myDate = new Date();
    const property = this.properties.find(
      (property) => property.pid == this.propIntelectualProject
    );
    const propertyName = property.name;
    const info_url = {
      date_creation: this.myDate.toString(),
      url: this.urlProject,
    };
    if (this.formRef.valid) {
      this.authService.getStatus().subscribe(
        (status) => {
          const project = {
            pid: pid.toString(),
            name: this.nameProject,
            description: this.descProject,
            parameters: this.formRef.get("items").value,
            info: this.listInfoUrl,
            user: this.userProject,
            pass: this.passProject,
            price: this.priceProject,
            creator: status.uid,
            date_creation: this.myDate.toString(),
            url_auth: currentUrl,
            prop_intellectual: propertyName,
            status: "activo",
            infourl: info_url,
          };
          this.projectService
            .setProject(project)
            .then(() => {
              alert("Proyecto Creado");
              this.cleanForm();
            })
            .catch((error) => {
              console.log(error);
            });
          const plan = {
            pid: this.planProject,
            duration: this.planDuration,
            type: this.planType,
            expiration: this.expDateProject,
          };
          this.projectService
            .setPlanProject(pid, plan)
            .then(() => {})
            .catch((error) => {
              console.log(error);
            });
        },
        (error) => {
          console.log(error);
        }
      );
    }

    if (this.croppedImage) {
      const pictures = this.fbStorage
        .ref("pictures/projects/" + pid + ".jpg")
        .putString(this.croppedImage, "data_url");
      pictures
        .then((result) => {
          this.picture = this.fbStorage
            .ref("pictures/projects/" + pid + ".jpg")
            .getDownloadURL();
          this.picture.subscribe(
            (p) => {
              this.projectService
                .setAvatarProject(p, pid)
                .then(() => {
                  this.imageChangedEvent = "";
                  this.croppedImage = "";
                })
                .catch((error) => {
                  alert("Hubo un error al subir la imagen");
                  console.log(error);
                });
            },
            (error) => {
              console.log(error);
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  onChange(idPlan) {
    const plan = this.plans.find((plan) => plan.pid === idPlan);
    this.planType = plan.type;
    if (plan.date_expiration) {
      const today = new Date();
      const expirationDate = new Date(plan.date_expiration);
      const diff = expirationDate.getTime() - today.getTime();
      const duration = Math.round(diff / (1000 * 60 * 60 * 24));
      this.planDuration = duration.toString();
      this.expDateProject = plan.date_expiration;
    } else {
      this.planDuration = plan.durationPlan;
      this.expDateProject = null;
    }
  }
  cleanForm() {
    this.createForm();
    this.nameProject = "";
    this.descProject = "";
    this.descProject = "";
    this.priceProject = "";
    this.planDuration = "";
    this.planType = "";
    this.protocolProject = "";
    this.hostProject = "";
    this.portProject = "";
    this.pathProject = "";
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
}
